module.exports = __webpack_public_path__ + "img/study-comp-new.e9f4c1fe.png";